import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";

const expConfig = {
  stages: {
    default: 1,
    main: 2,
    direct: 3,
    meta: 4,
    shortHaul: 5,
    mediumHaul: 6,
    longHaul: 7,
    domestic: 8,
    us: 9
  },
  goals: {
    desktop_sr_card_baggage_hover: 1,
    fd_open_for_affected_offers: 2
  }
};

const desktop = createTrackingUtils({
  ...expConfig,
  name: "flights_web_sr_baggage_transparency_ddot",
  defaultStage: 1
});

const mDot = createTrackingUtils({
  ...expConfig,
  name: "flights_web_sr_baggage_transparency_mdot",
  defaultStage: 1
});

const getExp = (isMobile: boolean) => {
  return isMobile ? mDot : desktop;
};

const trackStages = (isMobile: boolean, profiler: ReturnType<typeof useProfiler>) => {
  const { stages } = getExp(isMobile);
  const { isDirect, isShortHaul, isMediumHaul, isLongHaul, isAmerican } = profiler;

  stages.main();
  isDirect() ? stages.direct() : stages.meta();

  isShortHaul() && stages.shortHaul();
  isMediumHaul() && stages.mediumHaul();
  isLongHaul() && stages.longHaul();

  isAmerican() && stages.us();
};

export default { getExp, trackStages };
